import Api from "./api";
import { Technician as TechnicianModel } from "../models/Technician";

export class TechniciansActions {
  static get(name: string): Promise<TechnicianModel[]> {
    return Api.get("/technicians/search?q=" + name)
      .then((data: any) => {
        return data.data;
      })
      .catch((error: any) => console.log(error));
  }

  static getById(id: number): Promise<TechnicianModel> {
    return Api.get("/technicians/search/" + id)
      .then((data: any) => {
        return data.data;
      })
      .catch((error: any) => console.log(error));
  }

  static getByPhone(phone: string): Promise<TechnicianModel[]> {
    return Api.get("/technicians/search?q=" + phone)
      .then((data: any) => {
        return data.data;
      })
      .catch((error: any) => console.log(error));
  }

  static getTimeSlots(
    week = null,
    departmentId = -1,
    address = ""
  ): Promise<any> {
    let params = [];
    if (week) params.push(`week=${week}`);
    if (departmentId) params.push(`department_id=${departmentId}`);
    if (address) params.push(`address=${address}`);

    const joinedParams = params.join("&");
    const url = `/technicians/slots${joinedParams ? "?" + joinedParams : ""}`;
    return Api.get(url)
      .then((data: any) => {
        return data.data;
      })
      .catch((error: any) => console.log(error));
  }
}
